var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcApps"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container",attrs:{"id":""}},[_c('AppList',{attrs:{"pub":false,"canAdd":true}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }